export const STATIC_CLASSES = Object.freeze({
	root: 'banner1',
	grid: 'banner1-content',
	text: 'banner1-text-block',
	actionContainer: 'banner1-button-wrapper',
})
